import styled from 'styled-components';

import { Flex, Text } from '@amzn/storm-ui';
import { AMAZON_NAV_INKWELL } from '../../../../../Shared/constants/commonConstants';

export const ProfileIcon = styled(Text)`
  font-weight: bold;
  border-radius: 50%;
  font-size: 1.25rem;
  padding: 1.5rem 1.25rem;
  background-color: ${AMAZON_NAV_INKWELL};
  color: ${({ theme }) => theme.color.gray[50]};
`;

export const ProfileDetailsFlexCard = styled(Flex)`
  align-items: center;
  flex-direction: column;
`;


export const FormattedText = styled(Text)`
  font-size: 1rem;
  font-weight: bold;
  margin-top: 0.5rem;
  color: ${({ theme }) => theme.color.gray[700]};
`;

export const MemberSinceText = styled(Text)`
  color: ${({ theme }) => theme.color.gray[700]};
`;
